import type { ComponentDescription, Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

/**
 * Adds or updates the given component description to the DOLAN.
 *
 * @param dolan DOLAN to edit
 * @param description component description to add
 * @returns updated DOLAN with the component description installed
 */
export default function installComponentDescription(dolan: Dolan, description: ComponentDescription): Dolan {
  const components = dolan.components.slice(); // Copy for mutation
  const existingIndex = components.findIndex((desc) => desc.name === description.name);
  if (existingIndex >= 0) {
    components[existingIndex] = description;
  } else {
    components.push(description);
  }
  return { ...dolan, components };
}
